function Cancel({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      className={className}
    >
      <mask
        id="mask0_31109_955"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="26"
        height="26"
      >
        <rect width="26" height="26" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_31109_955)">
        <path
          d="M9.09989 18.0417L12.9999 14.1417L16.8999 18.0417L18.0415 16.9L14.1415 13L18.0415 9.10002L16.8999 7.95837L12.9999 11.8584L9.09989 7.95837L7.95825 9.10002L11.8582 13L7.95825 16.9L9.09989 18.0417ZM13.0017 23.2917C11.5783 23.2917 10.2403 23.0215 8.98785 22.4813C7.73535 21.9411 6.64586 21.208 5.71938 20.2819C4.79287 19.3558 4.05939 18.2668 3.51894 17.0148C2.97848 15.7629 2.70825 14.4253 2.70825 13.0018C2.70825 11.5784 2.97836 10.2404 3.51859 8.98797C4.05881 7.73547 4.79195 6.64599 5.71802 5.7195C6.64411 4.793 7.73312 4.05952 8.98506 3.51906C10.237 2.9786 11.5746 2.70837 12.9981 2.70837C14.4215 2.70837 15.7595 2.97849 17.0119 3.51871C18.2644 4.05893 19.3539 4.79208 20.2804 5.71815C21.2069 6.64423 21.9404 7.73325 22.4808 8.98518C23.0213 10.2371 23.2915 11.5748 23.2915 12.9982C23.2915 14.4216 23.0214 15.7596 22.4812 17.0121C21.941 18.2646 21.2078 19.354 20.2818 20.2805C19.3557 21.207 18.2667 21.9405 17.0147 22.481C15.7628 23.0214 14.4251 23.2917 13.0017 23.2917Z"
          fill="#B71C1C"
        />
      </g>
    </svg>
  );
}

export default Cancel;
